import { useQuery } from '@tanstack/react-query'

// AD-229: users the selected ads can be assigned to.
export const queryAdAssignableUsers = ({ ids = [] }) => {

    const query = useQuery({
        queryKey: ['ad-assignable-users', ids],
        enabled: ids.length > 0,
        retry: false,
        queryFn: async () => {
            const { data } = await axios.get(route('studio.v1.api.ads.assignable-users'), { params: { ids } });
            return data;
        },
    });

    return query;
}
